<div *ngIf="!displayMobileView" class="content-table-pointer">
  <ion-row class="content gray-md-rows color-black" (click)="edit()">
    <ion-col size="3">{{ row.level }}</ion-col>
    <ion-col size="3">{{ row.name }}</ion-col>
    <ion-col size="4">{{ row.description }}</ion-col>
    <ion-col *ngIf="permissionEdit" class="add-remove-col" size="2">
      <div class="ion-text-center">
        <ion-button type="close" size="medium" (click)="delete($event)">
          <ion-icon name="close" size="medium"></ion-icon>
        </ion-button>
      </div>
    </ion-col>
  </ion-row>
</div>

<ion-card *ngIf="displayMobileView" class="content-card" (click)="edit()">
  <ion-card-content class="mobile-header">
    <ion-grid class="no-padding-grid">
      <ion-row>
        <ion-col>
          <ion-text class="txt-info">{{ row.name }}</ion-text>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="line-divider"></div>
  </ion-card-content>

  <ion-grid class="no-padding-grid">
    <ion-row>
      <ion-col class="info-container">
        <ion-card-header>
          <div class="mobile-flex-header">
            <ion-card-subtitle class="mobile-subtitle">
              {{ "LEVEL" | translate }}
            </ion-card-subtitle>
            <ion-card-title>{{ row.level }}</ion-card-title>
          </div>
        </ion-card-header>
      </ion-col>
      <ion-col *ngIf="permissionEdit">
        <div class="ion-text-center">
          <ion-button type="close" size="medium" (click)="delete($event)">
            <ion-icon name="close" size="medium"></ion-icon>
          </ion-button>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-card-content class="mobile-footer">
    {{ row.description }}
  </ion-card-content>
</ion-card>
